import React, { PureComponent } from 'react';
import VerbButton, { VERB_BUTTON_TYPE } from '../../shared/components/VerbButton';
import VerbHeading from '../../shared/components/VerbHeading';
import PaginatedFetch from '../../shared/components/PaginatedFetch';
import PageContent from '../../shared/components/PageContent';
import Page from '../../shared/components/Page';

class DesignPage extends PureComponent {
    render = () => (
        <Page className={'design-page'}>
            <PageContent>
                <h1 className={'verb-title-1'}>Format Standards</h1>
                <h2>Dates</h2>
                <h4>MMM DD, YYYY (Jan 01, 2019)</h4>
                <h1 className={'verb-title-1'}>Buttons</h1>
                <div>
                    <h2> Light Background </h2>
                    <div>
                        <h3>Primary</h3>
                        <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS} fontAwesomeIcon={'fa-plus'} />
                        &nbsp;
                        <VerbButton buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}>PRIMARY TEXT</VerbButton>
                        &nbsp;
                        <VerbButton buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT} fontAwesomeIcon={'fa-plus'}>
                            PRIMARY TEXT
                        </VerbButton>
                    </div>
                    <div>
                        <h3>Mini</h3>
                        <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS} fontAwesomeIcon={'fa-plus'} />
                        &nbsp;
                        <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}>MINI TEXT</VerbButton>
                        &nbsp;
                        <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT} fontAwesomeIcon={'fa-plus'}>
                            MINI ICON TEXT
                        </VerbButton>
                    </div>
                </div>
                <div>
                    <h2> Dark Background </h2>
                    <div>
                        <h3>Primary</h3>
                        <div style={{ background: '#623285', padding: '10px' }}>
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                isDarkBackground={true}
                                fontAwesomeIcon={'fa-plus'}
                            />
                            &nbsp;
                            <VerbButton buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT} isDarkBackground={true}>
                                PRIMARY TEXT
                            </VerbButton>
                            &nbsp;
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                                isDarkBackground={true}
                                fontAwesomeIcon={'fa-plus'}
                            >
                                PRIMARY TEXT
                            </VerbButton>
                        </div>
                    </div>
                    <div>
                        <h3>Mini</h3>
                        <div style={{ background: '#623285', padding: '10px' }}>
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                isDarkBackground={true}
                                fontAwesomeIcon={'fa-plus'}
                            />
                            &nbsp;
                            <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT} isDarkBackground={true}>
                                MINI TEXT
                            </VerbButton>
                            &nbsp;
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                                isDarkBackground={true}
                                fontAwesomeIcon={'fa-plus'}
                            >
                                MINI ICON TEXT
                            </VerbButton>
                        </div>
                    </div>
                </div>
                <div>
                    <h2> Pagination </h2>
                    <PaginatedFetch fetchMoreFunc={() => {}} limit={0} />
                </div>
                <div>
                    <VerbHeading hNumber={1} defaultMessage={'Verb Heading 1'} />
                    <VerbHeading hNumber={2} defaultMessage={'Verb Heading 2'} />
                    <VerbHeading hNumber={3} defaultMessage={'Verb Heading 3'} />
                    <VerbHeading hNumber={4} defaultMessage={'Verb Heading 4'} />
                    <VerbHeading hNumber={5} defaultMessage={'Verb Heading 5'} />
                    <VerbHeading hNumber={6} defaultMessage={'Verb Heading 6'} />
                </div>
            </PageContent>
        </Page>
    );
}

export default DesignPage;
